import { identity, result, has } from 'underscore';
import { getBulkApiErrors } from '@bingads-webui-campaign/api-errors';

export const ERROR_ENTITY = {
  Campaign: 'campaign',
  AdGroup: 'adGroup',
  Ad: 'ResponsiveAd',
};

export const isBulkWrappedResponse = bulkResult => has(bulkResult, 'entity');

const getBulkUploadEntityType = entitySchema =>
  (entitySchema.properties['bulk-upload-type'] || {}).value ||
  entitySchema.name;

export const getBulkUploadErrorType = entitySchema =>
  `${getBulkUploadEntityType(entitySchema)} Error`;

export const mapBulkUpsertErrors = (
  errors,
  bulkUpsertEntityErrorMap,
  errorProcessor = identity,
  scenario,
  i18n,
  activityLogger
) =>
  getBulkApiErrors(errors, scenario, i18n, activityLogger).map((error) => {
    const errorType = error.type;
    const mappedErrorType = result(bulkUpsertEntityErrorMap, errorType, errorType);
    // eslint-disable-next-line no-param-reassign
    error.type = mappedErrorType;
    return errorProcessor(error);
  });

export const modelToViewModelForBulkErrors = (errors, bulkUpsertEntityErrorMap, scenario, i18n, activityLogger) =>
  mapBulkUpsertErrors(errors, bulkUpsertEntityErrorMap, /* errorProcessor */ identity, scenario, i18n, activityLogger);
